// D3 Chart Configuration following BodyOS design system
// Matches the isometric/typewriter aesthetic from chart_config.js

export const colors = {
  // Neutral grayscale palette - Primary chart colors
  neutral: {
    white: '#ffffff',
    50: '#fafafa',
    100: '#f5f5f5',
    200: '#e5e5e5',
    300: '#d4d4d4',
    400: '#a3a3a3',
    500: '#737373',
    600: '#525252',
    700: '#404040',
    800: '#262626',
    900: '#171717',
    black: '#000000'
  },

  // Transparent variants for fills
  neutralAlpha: {
    5: 'rgba(23, 23, 23, 0.05)',
    10: 'rgba(23, 23, 23, 0.1)',
    20: 'rgba(23, 23, 23, 0.2)',
    30: 'rgba(23, 23, 23, 0.3)',
    40: 'rgba(23, 23, 23, 0.4)',
    50: 'rgba(23, 23, 23, 0.5)'
  },

  // Chart-specific palette for multi-series data
  chart: [
    '#171717', // neutral-900 - primary
    '#525252', // neutral-600 - secondary
    '#a3a3a3', // neutral-400 - tertiary
    '#d4d4d4', // neutral-300 - quaternary
    '#404040', // neutral-700 - quinary
    '#737373' // neutral-500 - senary
  ],

  // Accent color for highlights
  accent: '#39ff14', // Neon green from design system

  // Semantic colors
  positive: '#22c55e',
  negative: '#ef4444',
  warning: '#f59e0b',

  // Grid and axes
  grid: '#e5e5e5',
  axis: '#171717',
  text: '#171717',
  textMuted: '#737373',
  textLight: '#a3a3a3'
}

export const fonts = {
  family: "'JetBrains Mono', 'Space Mono', 'Courier New', monospace",
  sizes: {
    xs: 9,
    sm: 10,
    base: 11,
    md: 12,
    lg: 14,
    xl: 16,
    '2xl': 20,
    '3xl': 24
  },
  weights: {
    normal: 400,
    medium: 500,
    semibold: 600,
    bold: 700
  }
}

export const spacing = {
  xs: 4,
  sm: 8,
  md: 16,
  lg: 24,
  xl: 32,
  '2xl': 48
}

export const defaultMargins = {
  top: 40,
  right: 40,
  bottom: 60,
  left: 60
}

export const defaultDimensions = {
  width: 800,
  height: 500
}

// Tooltip configuration
export const tooltipConfig = {
  backgroundColor: colors.neutral[900],
  textColor: colors.neutral.white,
  borderColor: colors.neutral[900],
  borderWidth: 2,
  padding: 12,
  fontSize: fonts.sizes.base,
  fontFamily: fonts.family
}

// Animation configuration
export const animationConfig = {
  duration: 750,
  easing: 'easeOutCubic',
  stagger: 50
}

// Axis configuration
export const axisConfig = {
  tickSize: 6,
  tickPadding: 8,
  fontSize: fonts.sizes.sm,
  fontFamily: fonts.family,
  color: colors.textMuted,
  lineColor: colors.axis,
  lineWidth: 2
}

// Grid configuration
export const gridConfig = {
  color: colors.grid,
  strokeWidth: 1,
  strokeDasharray: null // Solid lines for isometric aesthetic
}

// Legend configuration
export const legendConfig = {
  fontSize: fonts.sizes.base,
  fontFamily: fonts.family,
  itemSpacing: 24,
  symbolSize: 12,
  symbolSpacing: 8
}

export default {
  colors,
  fonts,
  spacing,
  defaultMargins,
  defaultDimensions,
  tooltipConfig,
  animationConfig,
  axisConfig,
  gridConfig,
  legendConfig
}
